module.exports = __webpack_public_path__ + "img/renb_03.f24a3607.png";